export const TOP_NAV_HEIGHT = 60
export const TOP_NAV_HEIGHT_PX = `${60}px`

// so the -100 offset, it just looks nice to move the target element up just a tad from the middle
export function scrollElIntoView(el, { behavior = 'smooth', offset = -100, alignment = 'middle' } = {}) {
  const top = calculateTop(el, offset, alignment)
  window.scrollTo({ behavior, left: 0, top })
}

function calculateTop(el, offset, alignment) {
  if (alignment === 'top') {
    return window.pageYOffset + el.getBoundingClientRect().top - TOP_NAV_HEIGHT - offset
  }

  return window.pageYOffset + el.getBoundingClientRect().top - TOP_NAV_HEIGHT - window.innerHeight / 2 - offset
}
